var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hello"},[_c('span',{staticClass:"number",class:_vm.changeNumber},[_vm._v(_vm._s(_vm.currentNumber))])])}
var staticRenderFns = []

export { render, staticRenderFns }